import { AgendaListCard } from "./AgendaListCard";

export default AgendaListCard;
